// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mr-15[data-v-3f026550] {\n  margin-right: 15px;\n}\n.buttons[data-v-3f026550] {\n  display: flex;\n  justify-content: center;\n}\n", ""]);
// Exports
module.exports = exports;
